import { actions } from '../constants/link';
import * as actionTypes from '../../models/action/link';
import { IAction } from '../../models/action/core';



// #region Add Link Action
export function addLinkGetAction(linkData: actionTypes.ILinkData, spinnerId?: string, spinnerType?: 'get' | 'set', callback?: (value: boolean) => void): actionTypes.IGetAddLink {
    return {
        linkData,
        spinnerId,
        spinnerType,
        timestamp: Date.now(),
        type: actions.ADD_LINK_ACTIVITY,
        callback
    };
}

// Add Link Update Get Action
export function updateLinkGetAction(
    dataParams: actionTypes.IUpdateLinkParams,
    spinnerId: string,
    spinnerType: 'get'|'set'
): actionTypes.IUpdateLinkGet {
    return {
        ...dataParams,
        spinnerId,
        spinnerType,
        timestamp: Date.now(),
        type: actions.ADD_LINK_UPDATE_ACTIVITY
    };
}

export function addLinkSetAction(linkData: actionTypes.ILinkData[] | null, addLinkStatus: boolean, spinnerId?: string, spinnerType?:'get'|'set'): actionTypes.ISetAddLink {
    return {
        linkData,
        addLinkStatus,
        spinnerId,
        spinnerType,
        timestamp: Date.now(),
        type: actions.ADD_LINK_SET_ACTIVITY
    };
}

export function setLinkDataDefault(spinnerId?: string, spinnerType?: 'get' | 'set'): IAction {
    return {
        spinnerId,
        spinnerType,
        timestamp: Date.now(),
        type: actions.SET_LINK_DATA_DEFAULT
    };
}
// #endregion Add Link Action


// #region Add Link Action
export function deleteLinkGetAction(
    data: actionTypes.DeleteData
): actionTypes.IGetDeleteLink {
    return {
        linkData: data,
        timestamp: Date.now(),
        type: actions.DELETE_LINK_ACTIVITY
    };
}

export function deleteLinkSetAction(deleteLinkStatus: boolean): actionTypes.ISetDeleteLink {
    return {
        deleteLinkStatus,
        timestamp: Date.now(),
        type: actions.DELETE_LINK_SET_ACTIVITY
    };
}
 // #endregion Add Link Action